// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styling for inline status-word / keystone-node glyphs produced by
   renderStatusText, so they render correctly on ANY tooltip surface (combat
   rail, skill-tree card side panel, …) — not just inside .combat-tt__desc. */

.status-word {
  display: inline-flex;
  align-items: baseline;
  gap: 2px;
  font-weight: 700;
  white-space: nowrap;
}
.status-word .status-word__icon {
  width: 13px;
  height: 13px;
  flex: 0 0 auto;
  transform: translateY(1.5px);
}

/* Keystone reference: the node glyph REPLACES the word (no trailing text). Sit it
   on the text baseline, a touch larger than a resource glyph since it stands alone.
   The tooltip-scoped (0,3,0) boosts of this rule (.combat-tt__desc /
   .combat-tt__section-label prefixes) relocated to GameTip.css with the shell
   (tooltip-canon kill-list item 7, 2026-06-12). */
.status-word--glyph-only {
  gap: 0;
  align-items: center;
  vertical-align: middle;
}
.status-word--glyph-only .status-word__icon {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  transform: translateY(-1px);
}
`, "",{"version":3,"sources":["webpack://./src/components/CombatPlayerbar/statusWordGlyphs.css"],"names":[],"mappings":"AAAA;;6EAE6E;;AAE7E;EACE,oBAAoB;EACpB,qBAAqB;EACrB,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,4BAA4B;AAC9B;;AAEA;;;;kDAIkD;AAClD;EACE,MAAM;EACN,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,2BAA2B;AAC7B","sourcesContent":["/* Shared styling for inline status-word / keystone-node glyphs produced by\n   renderStatusText, so they render correctly on ANY tooltip surface (combat\n   rail, skill-tree card side panel, …) — not just inside .combat-tt__desc. */\n\n.status-word {\n  display: inline-flex;\n  align-items: baseline;\n  gap: 2px;\n  font-weight: 700;\n  white-space: nowrap;\n}\n.status-word .status-word__icon {\n  width: 13px;\n  height: 13px;\n  flex: 0 0 auto;\n  transform: translateY(1.5px);\n}\n\n/* Keystone reference: the node glyph REPLACES the word (no trailing text). Sit it\n   on the text baseline, a touch larger than a resource glyph since it stands alone.\n   The tooltip-scoped (0,3,0) boosts of this rule (.combat-tt__desc /\n   .combat-tt__section-label prefixes) relocated to GameTip.css with the shell\n   (tooltip-canon kill-list item 7, 2026-06-12). */\n.status-word--glyph-only {\n  gap: 0;\n  align-items: center;\n  vertical-align: middle;\n}\n.status-word--glyph-only .status-word__icon {\n  width: 15px;\n  height: 15px;\n  flex: 0 0 auto;\n  transform: translateY(-1px);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
